import { type SpaceCategory, type SpaceOptions } from '@/utils/filters/options/getSpaceOptions';
import type { Filter } from '@cvent/venue-search-shared/types';
import { MAX_ATTENDEES_LIMIT } from '@/constants/filterConstants';

/**
 * Return array of space category by checking filters present in applicable filters.
 * If filter is already applied, then also add then it should be visible in filters.
 */
export function applicableFilterApplied(
  options: SpaceOptions,
  applicableFilters: string[],
  selected: Filter
): SpaceCategory[] {
  return options.values.filter(v => applicableFilters.includes(v.value) || selected[v.value]);
}

/**
 * Checks for filter present in applicableFilters or selected already.
 */
export function shouldVisible(filters: string[], applicableFilters: string[], selected: Filter): boolean {
  let isFilterPresent = false;
  filters.forEach(filter => {
    if (applicableFilters.includes(filter) || selected[filter]) {
      isFilterPresent = true;
    }
  });
  return isFilterPresent;
}

/**
 * Checks if Restaurant Venue type is selected.
 */
export function restaurantVenueTypeClicked(selected: Filter): boolean {
  return selected.VENUE_TYPE?.includes('RESTAURANT') ?? false;
}

/**
 * All filters applied count
 */
export function getAllFiltersAppliedCount(filter: Filter): number {
  let count = 0;
  Object.keys(filter)?.forEach(key => {
    switch (key) {
      case 'VENUE_TYPE':
      case 'AMENITIES':
      case 'COUNTRY_CODE':
      case 'PLANNER_TAGS':
      case 'CITY':
      case 'AREA_TYPE':
      case 'VENUE_DETAILS':
        count += filter[key]?.length ?? 0;
        break;
      case 'TOTAL_MEETING_SPACE':
      case 'EXHIBIT_SPACE':
      case 'LARGEST_ROOM':
      case 'SECOND_LARGEST_ROOM':
      case 'CAPACITY_STANDING':
      case 'CAPACITY_SEATED':
      case 'NUMBER_OF_MEETING_ROOMS':
      case 'NUMBER_OF_SLEEPING_ROOMS':
        if (filter[key]?.minimum !== null || filter[key]?.maximum !== null) {
          count++;
        }
        break;
      case 'CEILING_HEIGHT':
        if (filter[key]?.minimum !== null) {
          count++;
        }
        break;
      case 'RATINGS':
        count += filter[key]?.values?.length ?? 0;
        break;
      case 'MAXIMUM_DISTANCE':
      case 'AIRPORT_DISTANCE':
        if (filter[key]?.value !== null) {
          count++;
        }
        break;
      case 'CANCELLED_SPACE':
      case 'RATE_HISTORY':
        count++;
        break;
      default:
    }
  });
  return count;
}

/**
 * is attendee count valid for search input
 */
export function validateAttendees(attendeeCount: number | undefined): boolean {
  if (attendeeCount === undefined) {
    return true;
  }
  return attendeeCount <= MAX_ATTENDEES_LIMIT;
}
